// MediaManagerModal.jsx

import React, { useState, useEffect } from 'react';
import { storage } from '../firebase'; // Importa el Storage que exportaste
import { 
  ref, 
  listAll, 
  getDownloadURL, 
  uploadBytes, 
  deleteObject 
} from 'firebase/storage';
import './MediaManagerModal.css'; // Tus estilos de modal

const MediaManagerModal = ({ assistantId, onClose }) => {
  const [currentPath, setCurrentPath] = useState(`assistants/${assistantId}/`);
  const [items, setItems] = useState([]); // subcarpetas y archivos
  const [newFolderName, setNewFolderName] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);

  // Al montar o cambiar `currentPath`, listamos el contenido
  useEffect(() => {
    listCurrentPath();
  }, [currentPath]);

  // 1) Función para listar contenido en currentPath
  const listCurrentPath = async () => {
    try {
      const folderRef = ref(storage, currentPath);
      const res = await listAll(folderRef);

      // res.prefixes => son subcarpetas (prefixes)
      // res.items => son archivos
      const folderNames = res.prefixes.map((prefix) => ({
        name: prefix.name,
        fullPath: prefix.fullPath,
        type: 'folder',
      }));

      // Para cada archivo, obtenemos URL
      const filePromises = res.items.map(async (itemRef) => {
        const url = await getDownloadURL(itemRef);
        return {
          name: itemRef.name,
          fullPath: itemRef.fullPath,
          type: 'file',
          downloadURL: url,
        };
      });
      const fileNames = await Promise.all(filePromises);

      setItems([...folderNames, ...fileNames]);
    } catch (err) {
      console.error('Error listando path:', err);
    }
  };

  // 2) Crear carpeta => subimos un archivo ".keep" vacío
  const createFolder = async () => {
    if (!newFolderName.trim()) return;
    // Para "crear" la carpeta: subimos un archivo vacío
    // con path "assistants/assistantId/nuevaCarpeta/.keep"
    const path = `${currentPath}${newFolderName}/.keep`;
    const fileRef = ref(storage, path);

    try {
      const emptyBlob = new Blob([]); // contenido vacío
      await uploadBytes(fileRef, emptyBlob);
      setNewFolderName('');
      listCurrentPath();
    } catch (err) {
      console.error('Error creando carpeta:', err);
    }
  };

  // 3) Navegar dentro de una carpeta
  const goInsideFolder = (folderPath) => {
    // Asegurarnos de que termine con "/"
    const finalPath = folderPath.endsWith('/') ? folderPath : folderPath + '/';
    setCurrentPath(finalPath);
  };

  // 4) Subir nivel (ir atrás)
  const goUp = () => {
    if (currentPath === `assistants/${assistantId}/`) {
      // Ya estamos en la raíz, no subimos más
      return;
    }
    // Quitar el "/" final
    let pathNoSlash = currentPath.replace(/\/$/, '');
    // Buscar última "/"
    const idx = pathNoSlash.lastIndexOf('/');
    if (idx !== -1) {
      let parent = pathNoSlash.slice(0, idx);
      if (!parent.endsWith('/')) parent += '/';
      setCurrentPath(parent);
    }
  };

  // 5) Manejar input del archivo
  const handleFileChange = (e) => {
    if (e.target.files?.[0]) {
      setSelectedFile(e.target.files[0]);
    }
  };

  // 6) Subir archivo/imagen a la carpeta actual
  const uploadFile = async () => {
    if (!selectedFile) return;
    const fileRef = ref(storage, currentPath + selectedFile.name);
    try {
      await uploadBytes(fileRef, selectedFile);
      setSelectedFile(null);
      listCurrentPath();
    } catch (err) {
      console.error('Error subiendo archivo:', err);
    }
  };

  // 7) Eliminar archivo (o carpeta si no tiene nada dentro)
  const handleDelete = async (item) => {
    const confirmDel = window.confirm(`¿Eliminar ${item.name}?`);
    if (!confirmDel) return;
    const fileRef = ref(storage, item.fullPath);
    try {
      await deleteObject(fileRef);
      listCurrentPath();
    } catch (err) {
      console.error('Error eliminando:', err);
    }
  };

  return (
    <div className="media-manager-overlay">
      <div className="media-manager-modal">
        <button onClick={onClose} className="media-manager-close">X</button>
        <h2>Media Manager</h2>
        <p>Carpeta actual: <strong>{currentPath}</strong></p>

        <div>
          <button onClick={goUp}>Subir nivel</button>
        </div>

        <div className="list-container">
          {items.map(item => (
            <div key={item.fullPath} className="list-item">
              {item.type === 'folder' ? (
                <span style={{cursor:'pointer', color:'#61dafb'}}
                      onClick={() => goInsideFolder(item.fullPath)}>
                  [CARPETA] {item.name}
                </span>
              ) : (
                <>
                  <span>{item.name} </span>
                  <a href={item.downloadURL} target="_blank" rel="noreferrer">(ver)</a>{' '}
                  <button onClick={() => handleDelete(item)}>Eliminar</button>
                </>
              )}
            </div>
          ))}
        </div>

        <div className="create-folder">
          <input 
            type="text"
            placeholder="Nombre de carpeta"
            value={newFolderName}
            onChange={(e) => setNewFolderName(e.target.value)}
          />
          <button onClick={createFolder}>Crear Carpeta</button>
        </div>

        <div className="upload-file">
          <input type="file" onChange={handleFileChange} />
          <button onClick={uploadFile}>Subir Archivo</button>
        </div>

      </div>
    </div>
  );
};

export default MediaManagerModal;
